import Dropzone from "dropzone";
Dropzone.options.newImageLibraryImage = {
  parallelUploads: 1,
  timeout: 300000
};
